// STEP MOA-LIVE-VOICE-AUTO-WHISPER-1 · 브라우저 로컬 VAD (에너지 기반 · 발화 구간 → WAV).
// 방송 마이크 트랙을 읽기 전용으로 재사용 (트랙 stop/변경 없음).
import { rmsOf, encodeWav } from '@/lib/ramoWakeWordVosk';

export const AUTO_VAD = {
  frame: 2048,          // 16kHz 기준 128ms
  startRms: 0.02,       // 최소 발화 임계
  noiseMul: 3,          // 적응형 소음 바닥 × 배수
  startFrames: 2,       // 연속 2프레임(≈256ms) 이상일 때 발화 시작
  endSilenceMs: 700,    // 무음 0.7s → 구간 종료
  preRollMs: 640,       // 발화 시작 전 보존 (앞부분 잘림 방지)
  minSpeechMs: 450,     // 이보다 짧은 구간은 전송 안 함
  maxMs: 7500,          // 서버 상한(8s) 이하로 강제 분할
};

export const createAutoVad = () => {
  let ctx = null; let src = null; let node = null; let stream = null; let own = false;
  let stopped = false;
  const diag = { frames: 0, level: 0, noise: 0.005, dropShort: 0, segments: 0, ctxState: 'none' };

  const start = async ({ stream: s, ownStream, onSpeechStart, onSpeechEnd, onSegment }) => {
    stream = s; own = !!ownStream;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    ctx = new Ctx({ sampleRate: 16000 });
    if (ctx.state === 'suspended') { try { await ctx.resume(); } catch {} }
    src = ctx.createMediaStreamSource(stream);
    node = ctx.createScriptProcessor(AUTO_VAD.frame, 1, 1);
    let pre = []; let seg = null; let loud = 0;
    node.onaudioprocess = (ev) => {
      if (stopped) { pre = []; seg = null; return; }
      const d = new Float32Array(ev.inputBuffer.getChannelData(0));
      const ms = (d.length / ev.inputBuffer.sampleRate) * 1000;
      const r = rmsOf(d);
      diag.frames += 1; diag.level = r;
      const thr = Math.max(AUTO_VAD.startRms, diag.noise * AUTO_VAD.noiseMul);
      if (!seg) {
        pre.push(d);
        while (pre.length * ms > AUTO_VAD.preRollMs) pre.shift();
        if (r >= thr) loud += 1;
        else { loud = 0; diag.noise = diag.noise * 0.95 + r * 0.05; }
        if (loud >= AUTO_VAD.startFrames) {
          seg = { chunks: [...pre], ms: pre.length * ms, silence: 0, speechMs: loud * ms };
          pre = []; loud = 0;
          try { onSpeechStart?.(); } catch {}
        }
        return;
      }
      seg.chunks.push(d); seg.ms += ms;
      if (r >= thr * 0.7) { seg.silence = 0; seg.speechMs += ms; } else seg.silence += ms;
      if (seg.silence >= AUTO_VAD.endSilenceMs || seg.ms >= AUTO_VAD.maxMs) {
        const done = seg; seg = null;
        try { onSpeechEnd?.(); } catch {}
        if (done.speechMs < AUTO_VAD.minSpeechMs) { diag.dropShort += 1; return; }
        diag.segments += 1;
        try {
          onSegment?.({ blob: encodeWav(done.chunks, ctx.sampleRate), durationMs: Math.round(done.ms), speechMs: Math.round(done.speechMs) });
        } catch {}
      }
    };
    src.connect(node); node.connect(ctx.destination);
  };

  // 멱등 · 자동 감지가 소유한 연결만 해제. 방송 트랙(own=false)은 stop 하지 않음.
  const stop = () => {
    stopped = true;
    if (node) node.onaudioprocess = null;
    try { node?.disconnect(); } catch {}
    try { src?.disconnect(); } catch {}
    try { if (ctx && ctx.state !== 'closed') ctx.close().catch(() => {}); } catch {}
    if (own) { try { stream?.getTracks?.().forEach((t) => t.stop()); } catch {} }
    node = null; src = null; ctx = null; stream = null;
  };

  const getDiag = () => ({ ...diag, ctxState: ctx?.state || 'none' });

  return { start, stop, getDiag };
};

export default createAutoVad;
